class SliceReveal extends HTMLElement {
  constructor() {
    super();

    this.tl = null;
    this.sliceCount = 32;
    this.wrapper = null;
  }

  connectedCallback() {
    this.initTimeline();
  }

  createSlices() {
    if (this.wrapper) return this.wrapper;

    this.wrapper = document.createElement("div");
    this.wrapper.className = "slice-wrapper";

    const rect = this.getBoundingClientRect();
    const sliceHeight = Math.ceil(rect.height / this.sliceCount);
    const bg = getComputedStyle(this).backgroundImage;

    for (let i = 0; i < this.sliceCount; i++) {
      const piece = document.createElement("div");
      piece.className = "slice-piece";

      const top = i * sliceHeight;
      const height =
        i === this.sliceCount - 1 ? rect.height - top : sliceHeight;

      piece.style.top = `${top}px`;
      piece.style.height = `${height}px`;
      piece.style.transformOrigin = "top";
      piece.style.scaleY = 0;

      if (bg && bg !== "none") {
        piece.style.backgroundImage = bg;
        piece.style.backgroundSize = "cover";
        piece.style.backgroundPosition = `center ${-top}px`;
      }

      this.wrapper.appendChild(piece);
    }

    this.appendChild(this.wrapper);
    return this.wrapper;
  }

  initTimeline() {
    if (this.tl) return;

    const pieces = this.createSlices().querySelectorAll(".slice-piece");

    this.tl = gsap.timeline({
      scrollTrigger: {
        trigger: this,
        start: "top 0%",   // when section enters
        end: "bottom 10%",  // when section leaves
        scrub: true,        // 🔥 scroll = progress
        // markers: true     // enable for debugging
      },
      defaults: { ease: "none" }
    });

    this.tl.to(pieces, {
      scaleY: 1,
      stagger: {
        each: 1 / this.sliceCount, // evenly spread across scroll
        from: "end"
      }
    });
  }
}

customElements.define("slice-reveal", SliceReveal);
